import { render, staticRenderFns } from "./NewAIConfigurationModal.vue?vue&type=template&id=5ea197f8&scoped=true&lang=pug"
import script from "./NewAIConfigurationModal.vue?vue&type=script&lang=js"
export * from "./NewAIConfigurationModal.vue?vue&type=script&lang=js"
import style0 from "./NewAIConfigurationModal.vue?vue&type=style&index=0&id=5ea197f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea197f8",
  null
  
)

export default component.exports